<template>
	<vxe-modal v-model="showFlag" title="水表历史读数查询" :destroy-on-close="true" 
					remember :esc-closable="false" width="auto">
		<vxe-table  align="center" :data="dataList"  border height="500"  show-overflow="tooltip" size="mini"
						  resizable highlight-hover-row  row-id="id">
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="水表地址" field="meter_addr" width="120"></vxe-table-column>
				<vxe-table-column title="IMEI" field="imei" width="140"></vxe-table-column>
				<vxe-table-column title="IMSI" field="imsi" width="140"></vxe-table-column>
				<vxe-table-column title="电压" field="voltage" width="70"></vxe-table-column>
				<vxe-table-column title="信号指示" field="signal_indication" width="100"></vxe-table-column>
				<vxe-table-column title="抄表读数" field="read_data" width="100"></vxe-table-column>
				<vxe-table-column title="上报时间" field="read_time" width="160"></vxe-table-column>
		</vxe-table>
	</vxe-modal>
</template>

<script>
	export default {
		data(){
			return {
				showFlag:false,
				dataList:[],
			}
		},
		methods: {
			showView(list) {
				this.dataList = list;
				this.showFlag = true;
			}
		},
	}
</script>

<style>
</style>
